import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosPreVisualizacao = () => {
  const criterios = [
    {
      texto: 'A palavra-chave deve atender a todos os criterios',
      otimizado: false,
    },
    { texto: 'O ícone deve estar preenchido', otimizado: false },
    { texto: 'A thumbnail deve estar preenchida', otimizado: false },
    { texto: 'O título SEO deve estar otimizado', otimizado: false },
    {
      texto: 'A meta description deve estar otimizada',
      otimizado: false,
    },
    { texto: 'O nome do blog deve estar preenchido', otimizado: false },
  ];

  function validacoes(
    index,
    notaPalavraChave,
    notaIconUrl,
    notaThumbnail,
    notaTituloSeo,
    notaMeta,
    notaBlog
  ) {
    switch (index) {
      case 0:
        return notaPalavraChave === 1;
      case 1:
        return notaIconUrl === 1;
      case 2:
        return notaThumbnail === 1;
      case 3:
        return notaTituloSeo === 1;
      case 4:
        return notaMeta === 1;
      case 5:
        return notaBlog === 1;
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
